import React from 'react';
import { SUPPORT_EMAIL } from '../data/constants';
export function Footer() {
  return <footer className="bg-navy py-4" data-id="element-55" data-mp="3gezfnanhw34b">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-56" data-mp="3gg0xpz2xhpvj">
        <p className="text-xs leading-snug text-steel/80 sm:text-sm" data-id="element-57" data-mp="32o4cmezogg8n">
          © 2026 HOME APPLIANCE DIAGNOSTIC PRO™ — All Rights Reserved. HOME APPLIANCE
          DIAGNOSTIC PRO™ is a diagnostic and professional reference resource. It does
          not replace manufacturer service information, model-specific specifications,
          electrical safety procedures, professional technical training, regulated
          service procedures, or qualified professional judgment.
        </p>
        <p className="mt-1.5 text-xs font-semibold uppercase tracking-wide text-steel/80 sm:text-sm" data-id="element-58" data-mp="3qdf7jfucjgev">
          Terms &amp; Conditions • Privacy Policy • Contact Support:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="normal-case text-white underline decoration-electric underline-offset-2 transition-colors duration-150 ease-out hover:text-electric" data-id="element-59" data-mp="2a19uhoqc1syc">
            {SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    </footer>;
}